import { dateFormatterDayMonthYear, Spacer, TextCapitalized } from "@qivia/ui";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ElectricCharge } from "../electricChargingAPI";
import "../../../../i18n/i18n";

export const SidePanelRefunded = (props: { charge: ElectricCharge }) => {
  const { t } = useTranslation();
  const { charge } = props;

  if (charge.reimbursedAt === null || charge.reimbursementAmount === null) {
    return null;
  }

  return (
    <StyledContainer>
      <StyledTitle>
        <TextCapitalized>
          {t("electric_charging.sidePanel.refunded.title")}
        </TextCapitalized>
      </StyledTitle>
      <Spacer y={1} />
      <StyledRow>
        <TextCapitalized>
          {t("electric_charging.sidePanel.refunded.date")}
        </TextCapitalized>
        <StyledValue>
          {dateFormatterDayMonthYear(new Date(charge.reimbursedAt))}
        </StyledValue>
      </StyledRow>
      <Spacer y={1} />
      <StyledRow>
        <TextCapitalized>
          {t("electric_charging.sidePanel.refunded.amount")}
        </TextCapitalized>
        <StyledValue>
          {charge.reimbursementAmount.toFixed(2)}&nbsp;€
        </StyledValue>
      </StyledRow>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const StyledTitle = styled.div`
  ${typographies["Body/S"]};
  color: ${colors["colors/text/darkGrey"]};
`;

const StyledRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  ${typographies["Body/M"]};
`;

const StyledValue = styled.div`
  font-weight: 700;
`;
